'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _utilsLocalization = require('@bibliocommons/utils-localization');

var _baseBcReactComponent = require('@bibliocommons/base-bc-react-component');

var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);

var _baseLoader = require('@bibliocommons/base-loader');

var _baseLoader2 = _interopRequireDefault(_baseLoader);

var _baseAlerts = require('@bibliocommons/base-alerts');

var _baseIcons = require('@bibliocommons/base-icons');

var _contentAdvisoryTypePicker = require('../../content-advisory-type-picker');

var _contentAdvisoryTypePicker2 = _interopRequireDefault(_contentAdvisoryTypePicker);

var _loginLink = require('../../login-link');

var _loginLink2 = _interopRequireDefault(_loginLink);

var _simpleUgcForm = require('../../simple-ugc-form');

var _simpleUgcForm2 = _interopRequireDefault(_simpleUgcForm);

require('../styles/PrimaryContentAdvisoryEditor.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PrimaryContentAdvisoryEditor = function (_BcReactComponent) {
  _inherits(PrimaryContentAdvisoryEditor, _BcReactComponent);

  function PrimaryContentAdvisoryEditor(props) {
    _classCallCheck(this, PrimaryContentAdvisoryEditor);

    var _this = _possibleConstructorReturn(this, (PrimaryContentAdvisoryEditor.__proto__ || Object.getPrototypeOf(PrimaryContentAdvisoryEditor)).call(this, props));

    _this.bindAll('renderHeading');
    return _this;
  }

  _createClass(PrimaryContentAdvisoryEditor, [{
    key: 'componentDidMount',
    value: function componentDidMount() {/* For Testing Purposes */}
  }, {
    key: 'renderHeading',
    value: function renderHeading() {
      var advisoryType = this.props.advisoryType;

      var advisoryPart = '';
      if (advisoryType) {
        advisoryPart = _react2.default.createElement(_reactIntl.FormattedMessage, { id: advisoryType.toLowerCase() + '_advisory_type' });
      }
      return _react2.default.createElement(
        'h3',
        null,
        _react2.default.createElement(_baseIcons.ContentAdvisory, null),
        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'usercontent_type_content_advisory' }),
        advisoryType ? ' - ' : null,
        advisoryPart
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          advisoryBody = _props.advisoryBody,
          advisoryType = _props.advisoryType,
          handleAdvisoryBodyChange = _props.handleAdvisoryBodyChange,
          handleSubmit = _props.handleSubmit,
          handleCancel = _props.handleCancel,
          handleLogin = _props.handleLogin,
          intl = _props.intl,
          initializingStatus = _props.initializingStatus,
          characterLimit = _props.characterLimit,
          user = _props.user;


      if (initializingStatus.status === 'pending') {
        return _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(_baseLoader2.default, null)
        );
      }

      if (initializingStatus.status === 'failure') {
        return _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            _baseAlerts.AlertFailure,
            null,
            _react2.default.createElement('span', { className: 'icon-ok' }),
            (0, _utilsLocalization.localizeFromKey)(initializingStatus, intl)
          )
        );
      }
      if (user.loggedIn) {
        if (advisoryType !== null) {
          return _react2.default.createElement(
            'div',
            { className: 'cp-primary-content-advisory-editor well clearfix' },
            this.renderHeading(),
            _react2.default.createElement(_simpleUgcForm2.default, {
              placeholderText: advisoryType.toLowerCase() + '_field_placeholder',
              submitButtonText: 'add_content',
              characterLimit: characterLimit,
              body: advisoryBody,
              handleChange: handleAdvisoryBodyChange,
              handleSubmit: handleSubmit,
              handleCancel: handleCancel,
              isNew: true })
          );
        }

        return _react2.default.createElement(
          'div',
          { className: 'cp-primary-content-advisory-editor well' },
          this.renderHeading(),
          _react2.default.createElement(_contentAdvisoryTypePicker2.default, {
            advisories: this.props.advisories,
            bibId: this.props.bibId,
            handleSelect: this.props.handleAdvisoryTypeChange })
        );
      }

      return _react2.default.createElement(
        'div',
        { className: 'well' },
        _react2.default.createElement(
          _loginLink2.default,
          { handleLogin: handleLogin },
          _react2.default.createElement(_baseIcons.ContentAdvisory, null),
          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'login_to_add_content_advisory' })
        )
      );
    }
  }]);

  return PrimaryContentAdvisoryEditor;
}(_baseBcReactComponent2.default);

PrimaryContentAdvisoryEditor.propTypes = {
  bibId: _react.PropTypes.string.isRequired,
  advisories: _react.PropTypes.arrayOf(_react.PropTypes.shape({
    type: _react.PropTypes.string,
    userContentId: _react.PropTypes.string
  })).isRequired,
  advisoryType: _react.PropTypes.string,
  advisoryBody: _react.PropTypes.string,
  handleAdvisoryTypeChange: _react.PropTypes.func.isRequired,
  handleAdvisoryBodyChange: _react.PropTypes.func.isRequired,
  handleSubmit: _react.PropTypes.func.isRequired,
  handleCancel: _react.PropTypes.func.isRequired,
  handleLogin: _react.PropTypes.func.isRequired,
  characterLimit: _react.PropTypes.number,
  initializingStatus: _react.PropTypes.shape({
    status: _react.PropTypes.string
  }).isRequired,
  user: _react.PropTypes.shape({
    loggedIn: _react.PropTypes.bool
  }).isRequired,
  intl: _reactIntl.intlShape
};

PrimaryContentAdvisoryEditor.defaultProps = {
  characterLimit: 500
};

exports.default = (0, _reactIntl.injectIntl)(PrimaryContentAdvisoryEditor);


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/shared-ugc-editors/lib/components/primary-content-advisory-editor/components/PrimaryContentAdvisoryEditor.js
// module id = 1527
// module chunks = 1